
<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="modal-title font-weight-bold">Class Details</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div class="alert-comp">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <form action @submit.prevent="updateClass" autocomplete="off">
          <!-- CLASS LEVEL -->
          <div class="modal-body-row row d-none">
            <div class="col-12">
              <label for="classLevel" class="control-label label-compact"
                >Class Level</label
              >
              <select class="form-control">
                <option selected>{{ class_level }}</option>
              </select>
            </div>
          </div>

          <!-- BRANCH NAME -->
          <div class="modal-body-row row input-row">
            <div class="col-12">
              <label for="branchName" class="control-label label-compact"
                >Branch Name</label
              >
              <input
                type="text"
                v-model="form.class_name"
                class="form-control"
                id="branchName"
                required
                placeholder="Give the class a name"
              />
            </div>
          </div>

          <!-- SAVE CLASS -->
          <div class="modal-body-row row mb-0 button-row">
            <div class="col-12 d-flex flex-center">
              <button
                type="submit"
                class="btn btn-md btn-accent"
                ref="saveClassBtn"
              >
                Save Class
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "ClassDetailsModal",

  components: {
    Modal,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  props: {},

  data() {
    return {
      form: {
        id: localStorage.getItem("classId") || "",
        class_name: "",
      },
      class_level: localStorage.getItem("classLevel") || "",
      current_branch_name: localStorage.getItem("className") || "",
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,
    };
  },

  mounted() {
    this.form.class_name = this.current_branch_name;
  },

  methods: {
    ...mapActions(["updateClassName"]),

    updateClass() {
      this.$refs.saveClassBtn.disabled = true;
      this.$refs.saveClassBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.updateClassName(this.form)
        .then((response) => {
          if (response.code !== 200) {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = `An error occured while updating class name...`;

              this.$refs.saveClassBtn.disabled = false;
              this.$refs.saveClassBtn.innerHTML = "Save Class";
            }, 1000);
          }
          // HANDLE A 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.saveClassBtn.disabled = true;
              this.$refs.saveClassBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful';
            }, 1000);

            setTimeout(() => {
              let dialog_data = {
                msg: "Class name has been successfully updated!",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("closeTriggered");
            }, 3000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}

.alert-comp {
  position: relative;
  top: -40px;
  margin-bottom: -5px;
}

.input-row {
  @include breakpoint_max(sm) {
    margin-top: 10px;
  }
}

.button-row {
  @include breakpoint_max(sm) {
    margin-top: -10px !important;
    margin-bottom: -20px !important;
  }
}
</style>
